export default "__VITE_ASSET__5d39cfd5__"